import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=535bfa4c&scoped=true&"
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"
import style0 from "./cart.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cart.vue?vue&type=style&index=1&id=535bfa4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535bfa4c",
  null
  
)

export default component.exports